<script>
import appConfig from "@/app.config";
import LayoutMail from "@/router/layouts/LayoutMail";
import {hopThuModel} from "@/models/hopThuModel";
import {notifyModel} from "@/models/notifyModel";
import {CommonMethod} from "@/helpers/niceBytes";
import { CONSTANTS } from "@/helpers/constants";
import moment from "moment";

export default {
  page: {
    title: "Hộp thư",
    meta: [{name: "description", content: appConfig.description}],
  },
  components: {},
  props:["backListMail", "mailId"],
  data() {
    return {
      url:  process.env.VUE_APP_API_URL + 'files/view/',
      apiUrl: process.env.VUE_APP_API_URL,
      model: hopThuModel.baseJson(),
      showDeleteModal: false,
      notifyOption: {
        totalRows: 1,
        todoTotalRows: 1,
        currentPage: 1,
        numberOfElement: 1,
        perPage: 10,
        pageOptions: [10, 100],
        filter: null,
        isBusy: false,
        id: null,
        read: false,
      },
      notifyFields: [
        { key: "STT", label: "STT", class: "td-stt", thClass: 'hidden-sortable', sortable: false },
        {
          key: "userName",
          label: "Tài khoản",
          class: "td-username",
          sortable: true,
          thStyle: "text-align:center",
          thClass: 'hidden-sortable',
        },
        {
          key: "fullName",
          label: "Họ và tên",
          class: "td-ten",
          thClass: 'hidden-sortable',
          sortable: true,
        },
        {
          key: "chucVu",
          label: " Chức vụ",
          class: "td-donVi",
          thClass: 'hidden-sortable',
          sortable: true,
        },
        {
          key: "donVi",
          label: "Đơn vị",
          class: "td-donVi",
          thClass: 'hidden-sortable',
          sortable: true,
        },
      ],
      showDanhSachNguoiNhan: false,
      index:1,
    };
  },
  computed:{
    showAvatar(){
      if(this.model && this.model.user && this.model.user.avatar && this.model.user.avatar.fileId)
        return this.url + this.model.user.avatar.fileId;
      else return "/DTHU.png";
    },

  },
  created() {
    // let id = this.$route.params.id;
    let id = this.mailId;
    this.handleShowChiTietThu(id)
  },
  methods:{
    formatDateDownload(formatDate){
      let dateTemp = moment(formatDate, "DD-MM-YYYY HH:mm:ss");
      return dateTemp.format("DD_MM_YYYY_HH_mm_ss");
    },
    isThuDenRouter(){
      return this.$route.path == '/thu-den' || this.$route.path == '/thu-da-gui'
    },
    async handleDelete() {
      if (this.model.userMailId != 0 && this.model.userMailId != null && this.model.userMailId) {
        await this.$store.dispatch("mailStore/deleteMail", this.model.userMailId).then((res) => {
          if (res.resultCode === 'SUCCESS') {
            this.showDeleteModal = false;
          }
          this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage(res));
          this.backListMail();
        });
      }
    },
    handleShowDeleteModal(id) {
      this.model.userMailId = this.mailId;
      this.showDeleteModal = true;
    },
    async handleShowChiTietThu(id) {
      await this.$store.dispatch("mailStore/getById", id).then((res) => {
        if (res.resultCode === 'SUCCESS') {
          this.model = res.data;

          // this.dataNguoiNhan=res.data.nguoiNhans
          // this.dataCC=res.data.cc
          // this.showChiTietModal = true;
          console.log(this.model.read)
          if(this.$route.path == '/thu-den'){
            if(!this.model.read){
              this.handleChangeStatus(this.model.userMailId);
            }
          }

        } else {
          this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage(res));
          this.$router.push('/thu-den');
        }
      });
    },
    async handleChangeStatus(id) {
      await this.$store.dispatch("mailStore/changeStatus", id).then((res) => {
        if (res.resultCode != 'SUCCESS') {
          this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage(res));
        }else {
          this.$store.commit('notifyStore/SET_RELOADNOTIFY', !this.$store.state.notifyStore.isReloadNotify);
        }
      });
    },
    convertByteToNice(size){
      return CommonMethod.niceBytes(size);
    },
    handlePushRouter(url){
      this.$router.push(url);
    },
    handleShowDanhSachNguoi(){
      this.showDanhSachNguoiNhan = true;
    },
    handleShowFile(id) {
      let route = this.$router.resolve({path: '/xem-tep-tin/' + id});
      window.open(route.href, '_blank');
    },
    myProviderNotify(ctx) {
      const params = {
        start: ctx.currentPage,
        limit: ctx.perPage,
        content: this.filter,
        sortBy: ctx.sortBy,
        sortDesc: ctx.sortDesc,
        id: this.model.mailId,
      }

      try {
        let promise = this.$store.dispatch("mailStore/getUserByHopThuId", params)
        return promise.then(resp => {
          if (resp.resultCode == CONSTANTS.SUCCESS) {
            let data = resp.data;
            this.notifyOption.totalRows = data.totalRows
            let items = data.data
            this.notifyOption.numberOfElement = items.length
            return items || []
          } else {
            return [];
          }
        })
      } finally {
        this.loading = false
      }
    },
  }
};
</script>

<template>
  <div>
    <div class="card">
      <div class="btn-toolbar p-3 d-flex justify-content-between">
        <b-button class="me-1" variant="light" @click="backListMail" title="Trở lại">
          <i class="fas fa-backspace text-primary"></i>
          <span class="d-none d-md-inline-block ms-1">Trở lại</span>
        </b-button>
        <div class="">
          <b-button-group size="md">
            <b-button class="me-1" variant="light" v-if="isThuDenRouter()" @click="handlePushRouter(`/hop-thu/tra-loi/${model.userMailId}`)"  title="Chuyển tiếp">
              <i class="fas fa-reply text-info"></i>
              <span class="d-none d-md-inline-block ms-1">Trả lời</span>
            </b-button>
            <b-button class="me-1" variant="light" v-if="isThuDenRouter()" @click="handlePushRouter(`/hop-thu/tra-loi-tat-ca/${model.userMailId}`)"  title="Chuyển tiếp">
              <i class="fas fa-reply text-info"></i>
              <span class="d-none d-md-inline-block ms-1">Trả lời tất cả</span>
            </b-button>
            <b-button class="me-1" variant="light"  v-if="isThuDenRouter()" @click="handlePushRouter(`/hop-thu/chuyen-tiep/${model.userMailId}`)" title="Chuyển tiếp">
              <i class="fas fa-reply-all text-primary"></i>
              <span class="d-none d-md-inline-block ms-1">Chuyển tiếp</span>
            </b-button>
            <b-button class="me-1" variant="light" v-if="isThuDenRouter()" @click="handleShowDeleteModal" title="Xóa thư">
              <i class="fas fa-trash-alt text-danger"></i>
              <span class="d-none d-md-inline-block ms-1">Xoá</span>
            </b-button>
            <b-button class="me-1" variant="success" @click="handleShowDanhSachNguoi" title="Người nhận">
              <i class="fas fa-user-friends text-white"></i>
              <span class="d-none d-md-inline-block ms-1">Người nhận</span>
            </b-button>
          </b-button-group>
        </div>
      </div>
      <div class="card-body px-4" style="padding-top: 0px !important;">
        <h3 class="mt-0 font-size-18" style="font-weight: bold">{{model.title}}</h3>
        <div class="d-flex justify-content-between pt-2">
          <div class="d-flex mb-4" v-if="model.user">
            <img
                class="flex-shrink-0 me-3 rounded-circle avatar-sm"
                :src="showAvatar"
                alt="Generic placeholder image"
            />
            <div class="flex-grow-1">
              <h4 class="font-size-15 m-0">{{model.user.fullName}} @{{model.user.userName}}</h4>
              <small class="text-muted">{{model.user.chucVu}} - {{model.user.donVi}} </small>
            </div>
          </div>
          <small class="text-muted" v-if="model.dateSendFull" style="float: right;"><i>Ngày gửi: {{model.dateSendFull}}</i></small>
        </div>
        <p v-html="model.content"></p>
        <hr style="margin-bottom: 10px"/>

        <div class="row">
          <div v-for="(value, index) in model.files" :key="index" class="col-xl-4 col-6">
            <div class="card border shadow-none mb-2">
              <a  class="text-body">
                <div class="p-2">
                  <div class="d-flex align-items-center">
                    <div class="avatar-xs align-self-center me-2">
                      <div class="avatar-title rounded bg-transparent text-danger font-size-20" v-if="value.ext == '.pdf'">
                        <i class="mdi mdi-file-pdf" ></i>
                      </div>
                      <div class="avatar-title rounded bg-transparent text-primary font-size-20"  v-else-if="value.ext == '.doc' || value.ext == '.docx'">
                        <i class="mdi mdi-file-word"></i>
                      </div>
                      <div class="avatar-title rounded bg-transparent text-success font-size-20"  v-else-if="value.ext == '.xls' || value.ext == '.xlsx'">
                        <i class="mdi mdi-microsoft-excel"></i>
                      </div>
                      <div class="avatar-title rounded bg-transparent text-success font-size-20"   v-else-if="value.ext == '.jpg' || value.ext == '.png'">
                        <i class="mdi mdi-image"></i>

                      </div>
                      <div class="avatar-title rounded bg-transparent font-size-20"   v-else>
                        <i class="mdi-file"></i>
                      </div>
                    </div>

                    <a :href="`${apiUrl}files/view/${value.fileId}/${formatDateDownload(model.dateSendFull)}`" class="overflow-hidden me-auto">
                      <h5 class="font-size-13 text-truncate mb-1">{{value.fileName}}</h5>
                      <p class="text-muted text-truncate mb-0 font-size-11">{{convertByteToNice(value.size)}}</p>
                    </a>
                    <div v-if="value.ext == '.pdf'">
                      <a
                          target="_blank"
                          class="fw-medium text-danger font-size-13 "
                          @click="handleShowFile(value.fileId)"
                          style="cursor: pointer"
                      >
                        [Xem]</a
                      >
                    </div>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--        Modal delete -->
    <b-modal
        v-model="showDeleteModal"
        centered
        title="Xóa thư"
        title-class="fw-bold fs-5 text-dark"
        no-close-on-backdrop
    >
      <p>
        Bạn chắc chắn muốn xóa?
      </p>
      <template #modal-footer>
        <b-button v-b-modal.modal-close_visit
                  size="sm"
                  class="btn btn-outline-info w-md"
                  v-on:click="showDeleteModal = false">
          Đóng
        </b-button>
        <b-button v-b-modal.modal-close_visit
                  size="sm"
                  variant="danger"
                  type="button"
                  class="w-md"
                  v-on:click="handleDelete">
          Xóa
        </b-button>
      </template>
    </b-modal>

    <b-modal
        v-model="showDanhSachNguoiNhan"
        centered
        title="Danh sách người nhận"
        title-class="fw-bold fs-5 text-dark"
        no-close-on-backdrop
        size="lg"
        hide-footer
    >
      <div class="row">
        <div class="col-12">

          <div class="table-responsive mb-0">
            <b-table
                class="datatables"
                :items="myProviderNotify"
                :fields="notifyFields"
                striped
                bordered
                responsive="sm"
                :per-page="notifyOption.perPage"
                :current-page="notifyOption.currentPage"
                :sort-by.sync="notifyOption.sortBy"
                :sort-desc.sync="notifyOption.sortDesc"
                ref="tblList1"
                primary-key="id"
                :busy.sync="notifyOption.isBusy"
            >
              <template v-slot:cell(STT)="data">
                {{ data.index + ((notifyOption.currentPage - 1) * notifyOption.perPage) + 1 }}
              </template>
              <template v-slot:cell(chucVu)="data">
                <div v-if="data.item.chucVu">
                  {{ data.item.chucVu }}
                </div>

              </template>
              <template v-slot:cell(donVi)="data">
                <div v-if="data.item.donVi">
                  {{ data.item.donVi }}
                </div>
              </template>

            </b-table>
            <template v-if="notifyOption.isBusy">
              <div align="center">Đang tải dữ liệu</div>
            </template>

            <template v-if="notifyOption.totalRows <= 0 && !notifyOption.isBusy">
              <div align="center">Không có dữ liệu</div>
            </template>
          </div>

          <div>
            <div class="row mb-2">
              <div class="col-sm-12 col-md-6">
                <div style="display: flex; justify-content: start; align-items: center">
                  <div style="margin-right: 20px" class="">
                    <div id="tickets-table_length" class="dataTables_length">
                      <label class="d-inline-flex align-items-center">
                        Hiện
                        <b-form-select
                            class="form-select form-select-sm"
                            v-model="notifyOption.perPage"
                            size="sm"
                            :options="notifyOption.pageOptions"
                        ></b-form-select
                        >&nbsp;dòng
                      </label>
                    </div>

                  </div>
                  <div class="">
                    <div>Hiển thị {{ notifyOption.numberOfElement }} trên tổng số {{ notifyOption.totalRows }} dòng</div>
                  </div>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div
                    class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                        v-model="notifyOption.currentPage"
                        :total-rows="notifyOption.totalRows"
                        :per-page="notifyOption.perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

    </b-modal>
  </div>
</template>
<style>
.hidden-sortable:after, .hidden-sortable:before {
  display: none !important;
}
</style>
